/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { userFullName } from '../../../../libs/HelperContent';
import { LoginContext } from '../../../../App';
import { deviceAndLocation, getMeetingsList, getPublicMeetingData } from '../../../actions/meeting_actions';
import deviceInfo from '../../../../libs/BrowserDevices';
import MeetingJoin from '../MeetingJoin';
import { LanguageContext } from '../../../../libs/Context';
import SharePost from '../../../NewsFeed/components/SharePost';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';

const MeetingVc = () =>
{
	const session = useSelector((state:any) => state?.mysession?.session);
	const { socket } = useContext(LoginContext);
	const { language } = useContext(LanguageContext);
	const params = useParams();
	const name:any = new URLSearchParams(window.location.search).get('name');
	const email:any = new URLSearchParams(window.location.search).get('email');
	const password:any = new URLSearchParams(window.location.search).get('password');
	const url = new URL(window.location.href);
	const emailConversion = email ? window.atob(email) : '';
	const navigate = useNavigate();
	const displayName:any = name || (Object?.keys(session)?.length > 0
		? userFullName(session)
		: emailConversion);
	const environment = process.env.REACT_APP_STAGE;
	const [ meetingData, setMeetingData ] = useState<any>({});
	const [ isPassword, setIsPassword ] = useState(false);
	const [ share, setShare ] = useState<any>(null);

	const emailId:any = (Object?.keys(session)?.length > 0 ? window.btoa(session?.email) : email || '');
	const emailQuery = emailId ? `&uid=${emailId}` : '';
	const nameQuery = displayName ? `&displayName=${window.btoa(displayName)}` : '';
	const [ isLoading, setIsLoading ] = useState(true);

	const handleLoad = () =>
	{
		setIsLoading(false);
	};
	const device = deviceInfo();

	const saveUserLocation = async () =>
	{
		try
		{
			const response = await fetch(process.env.REACT_APP_INMEET_LOCATION || '');
			const data = await response.json();
			const CountryName = data?.country || '';

			const body = {
				meetingId    : meetingData?.meetingDetails?.meetingId,
				sessionId    : window.atob(params?.session ?? ''),
				scheduledBy  : meetingData?.meetingDetails?.scheduledBy,
				startTimeUTC : meetingData?.meetingDetails?.startTimeUTC,
				endTimeUTC   : meetingData?.meetingDetails?.endTimeUTC,
				deviceInfo   : device.platform,
				location     : CountryName,
				scheduleType : 'schedule',
				groupId      : meetingData?.meetingDetails?.groupId
			};

			await deviceAndLocation(body);
			// }
		}
		catch (err)
		{
			console.error('Error saving user location:', err);
		}
	};

	const MeetingUrl = () =>
	{
		if (params?.type === 'share')
		{
			const scheduleType:any = new URLSearchParams(window.location.search).get('scheduleType');
			const screenShareUrl = `${process.env.REACT_APP_SHARESCREEN__INMEET}${window.atob(params?.session ?? '')}?projectId=${process.env.REACT_APP_VIDEO_ID}&displayName=${displayName}${emailQuery}&env=${environment}&meetingType=${window.btoa(scheduleType)}&screenshare=true`;

			return screenShareUrl;
		}
		else
		{
			return `${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}${window.atob(params?.session ?? '')}?projectId=${process.env.REACT_APP_VIDEO_ID}${nameQuery}${emailQuery}&profileKey=${session?.userId}&env=${environment}&meetingType=${window.btoa('schedule')}&lan=en&groupId=${session?.companyId ?? ''}`;
		}
	};

	const getMeetingsData = async () =>
	{
		try
		{
			const query = {
				id : window.atob(params?.session ?? '')
			};

			const res = await getMeetingsList(query);

			if (res?.status)
			{
				if (password)
				{
					url.searchParams.delete('password');
					history.replaceState(null, '', url.toString());
				}
				if (res?.data?.meetingDetails?.meetingPassword && !password)
				{
					setIsPassword(true);
				}
				else
				{
					setIsPassword(false);
				}

				setMeetingData(res?.data);
			}
		}

		catch (err)
		{
			setMeetingData({});

			console.log(err, '---------------');
		}
	};

	const getPublicMeetingsData = async () =>
	{
		try
		{
			const query = {
				id : window.atob(params?.session ?? '')
			};

			const res = await getPublicMeetingData(query);

			if (res?.data?.status)
			{
				if (res?.data?.data?.meetingDetails?.meetingPassword)
				{
					setIsPassword(true);
					setIsLoading(false);
				}
				else
				{
					setIsPassword(false);
					setIsLoading(true);
				}
				setMeetingData(res?.data?.data);
			}
		}

		catch (err)
		{
			console.log(err, '---------------');
			setIsPassword(false);
			setMeetingData({});
			setIsLoading(false);
		}
	};

	useEffect(() =>
	{
		if (params?.session)
		{
			if (session?.userId)
			{
				getMeetingsData();
			}
			else
			{
				getPublicMeetingsData();
			}
		}
	}, [ session, params ]);

	const checkEvent = (data) =>
	{
		if (typeof data !== 'string') return false;

		if (data === 'JOIN_VC_CANCEL') return true;

		try
		{
			const parsedData = JSON.parse(data);

			if (parsedData?.key && parsedData?.key === 'sharingMeetingDetails')
			{
				setShare(parsedData);
			}
			if (parsedData.cmd)
			{
				return Boolean(parsedData.cmd === 'END_STATUS');
			}
			else
			{
				return false;
			}
		}
		catch
		{
			return false;
		}
	};

	useEffect(() =>
	{
		const handleEvent = (event) =>
		{
			if (checkEvent(event.data))
			{
				console.log('********cal');
				navigate('/meetings');
			}
		};

		window.addEventListener('message', handleEvent);

		return () =>
		{
			window.removeEventListener('message', handleEvent);
		};
	}, []);

	// useEffect(() =>
	// {
	// 	if (socket)
	// 	{
	// 		socket.on('exit_training', (data:any) =>
	// 		{
	// 			if (data)
	// 			{
	// 				navigate('/meetings');
	// 			}
	// 		});

	// 		return () =>
	// 		{
	// 			socket.off('exit_training');
	// 		};
	// 	}
	// }, [ socket ]);

	useEffect(() =>
	{
		if (meetingData && Object.keys(meetingData)?.length > 0)
		{
			saveUserLocation();
		}
	}, [ meetingData ]);

	const HandleClose = () =>
	{
		setIsPassword(false);
		navigate('/meetings');
	};

	return (
		<div className='flexRow webinarJoinScreen alignCntr justifyCntr'>
			<div className='flexCol webinarFullScreen justifyBtwn'>
				{isLoading && <Loading />}
				{isPassword
					? 	(
						<MeetingJoin
							openTime={isPassword}
							heading={'Enter Meeting Password'}
							acceptBtn={language?.join_meeting}
							meetingId={Number(meetingData?.meetingDetails?.uniqueMeetingID)}
							from='join'
							handleClosePopup={HandleClose}
							handleConfirm={() => setIsPassword(false)}
							isPassword={isPassword}
						/>
					)
					: 					(
						<iframe
							title='hostscreen'
							id='conference'
							allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; camera; microphone; fullscreen; speaker; display-capture'
							src={MeetingUrl()}
							style={{ height  : 'var(--percent100)',
								width   : 'var(--percent100)',
								border  : 0,
								display : isLoading ? 'none' : 'block'
							}}
							onLoadCapture={handleLoad}
						/>)
				}
				<div className={share ? 'flexCol fxdSocialMediaSlider slideIn' : 'displayNone'} >
					{share && Object?.keys(share)?.length > 0 &&
						<SharePost meetingVC={share?.value?.shareLink} handleCloseShare={() => setShare(null)} mediaData={{ _id: window.atob(params?.session ?? '') }} type='meetingVC'/>
					}
				</div>
			</div>
		</div>
	);
};

export default MeetingVc;